import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from '../pages/Home';
import MarketPage from '../pages/Markets';
import LoginPage from '../pages/LoginPage';
import NotFound from '../pages/NotFound';
import AdminRoute from '../components/AdminRoute';
import AdminDashboard from '../pages/admin/AdminDashboard';
import UsersBotsPage from '../pages/admin/UsersBotsPage';
import InvoicesPage from '../pages/admin/InvoicesPage';
import UnpaidPage from '../pages/admin/UnpaidPage';
import SettingsPage from '../pages/admin/SettingsPage';

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/market" element={<MarketPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/admin/dashboard" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
      <Route path="/admin/users" element={<AdminRoute><UsersBotsPage /></AdminRoute>} />
      <Route path="/admin/invoices" element={<AdminRoute><InvoicesPage /></AdminRoute>} />
      <Route path="/admin/unpaid" element={<AdminRoute><UnpaidPage /></AdminRoute>} />
      <Route path="/admin/settings" element={<AdminRoute><SettingsPage /></AdminRoute>} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
